import { useContext } from 'react'
import ContextStates from '../context/ContextStates';
import Layout from '../components/Layout'
import FormCompra from '../components/admin/formCompra';

const Compra = () => {
    const { estadoJornada, roles, idUsuario } = useContext(ContextStates)
    return (
        <Layout
            pagina="Compras"
        >
            <main className='h-full'>
                <div className='w-full h-full bg-white'>
                    <FormCompra />
                </div>
            </main>
        </Layout>
    )
}

export default Compra